import React from 'react';
import { Badge as AntBadge } from 'antd';

/**
 * Wrapper component for Ant Design Badge
 * 
 * This wrapper allows us to easily replace Ant Design in the future without changing all imports.
 * It preserves all Ant Design Badge functionality including count, dot, and status options.
 * 
 * @component
 * @example
 * import { Badge } from '../GeneralComponents/ui';
 * 
 * <Badge count={5}>
 *   <a href="#" className="head-example" />
 * </Badge>
 * 
 * <Badge count={0} showZero>
 *   <a href="#" className="head-example" />
 * </Badge>
 * 
 * <Badge dot>
 *   <a href="#" className="head-example" />
 * </Badge>
 * 
 * @see https://ant.design/components/badge/ - Ant Design Badge documentation
 */
const Badge = (props) => {
  return <AntBadge {...props} />;
};

export default Badge;

